import { render, staticRenderFns } from "./Faturas-Duplicadas.vue?vue&type=template&id=7dcaf65c&scoped=true&"
import script from "./Faturas-Duplicadas.vue?vue&type=script&lang=js&"
export * from "./Faturas-Duplicadas.vue?vue&type=script&lang=js&"
import style0 from "./Faturas-Duplicadas.vue?vue&type=style&index=0&id=7dcaf65c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcaf65c",
  null
  
)

export default component.exports